var React = require('react');

function FilesInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.77778 0H3.05556V1.71111H3.78889V0.733333H9.77778C10.0473 0.733333 10.2667 0.952722 10.2667 1.22222V7.94444C10.2667 8.21394 10.0473 8.43333 9.77778 8.43333H8.06667V9.16667H9.77778C10.4531 9.16667 11 8.61972 11 7.94444V1.22222C11 0.546944 10.4531 0 9.77778 0ZM5.01111 2.44444H4.27778H0V11H7.33333V5.5V4.76667L5.01111 2.44444ZM6.6 10.2667H0.733333V3.17778H4.27778V5.5H6.6V10.2667ZM6.29628 4.76667H5.01111V3.4815L6.29628 4.76667ZM9.16667 1.83333H5.43706L6.17039 2.56667H9.16667V1.83333Z","fill":"white"}));
}

FilesInline.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","role":"img","aria-hidden":"true","focusable":"false"};

module.exports = FilesInline;

FilesInline.default = FilesInline;
